module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAALJJREFUWEftlcENwyAQBL1FuAlzPOjARThpIk047aQeSDNIkNhSJEtBwGftz1HA7dywAgwXH1ycPyiAGlADaoBqwBgzhRDetceOBiAiK4AlpXSvQdAAtq17IKgAPRB0gBbEH4CIzKQfci51ogSQSQD7WADhWMzTDAAYc86vL8PTe7/+ljylA9baWyl8N8LUvc2uhdMBWuFUgJ5wKoBzbowxPo6FK103vQOtjimAGlADauADDHJkIRMBiNEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/right.png
// module id = 4lFH
// module chunks = 0